import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { TeeButton } from '@/components/ui/tee-button';

export interface InboxEmptyStateProps {
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
  tone?: 'empty' | 'error';
}

export const InboxEmptyState: React.FC<InboxEmptyStateProps> = ({
  title,
  body,
  actionLabel,
  onAction,
  tone = 'empty',
}) => (
  <div
    role={tone === 'error' ? 'alert' : undefined}
    className="flex flex-col items-center justify-center text-center gap-3 px-6 py-12 h-full"
  >
    {tone === 'error' && (
      <AlertTriangle
        size={28}
        aria-hidden="true"
        className="text-[var(--color-maroon)]"
      />
    )}
    <h2 className="text-[20px] font-semibold font-[family-name:Urbanist,sans-serif] text-[var(--text-content-title)]">
      {title}
    </h2>
    {body && (
      <p className="text-[14px] text-[var(--text-content-sub-title)] max-w-[320px]">
        {body}
      </p>
    )}
    {actionLabel && onAction && (
      <TeeButton
        variant="secondary"
        size="m"
        text={actionLabel}
        onClick={onAction}
      />
    )}
  </div>
);

export default InboxEmptyState;
